import React, { useState } from 'react'
import PropTypes from 'prop-types'

import DetailsList from './DetailsList';

import { StyledCard } from 'ui/StyledComponents/StyledCard';

import { Box, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const Section = ({ organization, onOrganizationChange, onEdit }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <StyledCard>
      <Box sx={{ p: 2, borderBottom: expanded ? "1px solid rgba(0,0,0,0.1)" : "none", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="subtitle2">Profile Elements</Typography>
        <IconButton 
          size="small" 
          onClick={toggleExpanded}
        >
          {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
        </IconButton>
      </Box>

      {expanded && (
        <DetailsList 
          organization={organization}
          onOrganizationChange={onOrganizationChange}
          onEdit={onEdit}
        />
      )}
    </StyledCard>
  );
};

Section.propTypes = {
  organization: PropTypes.object,
  onOrganizationChange: PropTypes.func,
  onEdit: PropTypes.func,
};

export default Section;